import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from 'modules/redux/constants'
import setReduxAction from 'modules/redux/actions/set'
import logUtil from 'utils/log'
import { PRODUCTS_KEY, PRODUCTS_PATH } from 'modules/product/redux/constants.js'

export default function updateCurrentDateProductsAction (date) {
  return (dispatch) => {
    logUtil('updateCurrentDateProductsAction').debug(`[start] date=${date}`)

    const path = PRODUCTS_PATH[PRODUCTS_KEY.CURRENT_DATE]
    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.UPDATE,
      path,
      date
    )

    dispatch(
      setReduxAction({
        type: action,
        payload: {
          path,
          value: date
        }
      })
    )
  }
}
